<div id="weatherEn" style="display: none">
  <div class="row">
    <div class="column-large">
      <p>
        The weather at the <b> {{ main_location }} </b>
      </p>
    </div>
    <div class="column-small">
      <a
        class="weatherwidget-io"
        [attr.href]="weatherHrefEn"
        data-font="Roboto"
        data-icons="Climacons Animated"
        data-mode="Current"
        data-textcolor="#696969"
        data-highcolor="#696969"
        data-lowcolor="#696969"
        data-suncolor="#ffc676"
        data-mooncolor="#d6c2a6"
        data-cloudcolor="#c3bfb9"
        data-cloudfill="#c3bfb9"
        data-raincolor="#588edb"
        data-snowcolor="#588edb"
      >
        Karteros, Greece
      </a>
    </div>
  </div>

  <a
    class="weatherwidget-io"
    [attr.href]="weatherHrefEn"
    data-font="Roboto"
    data-icons="Climacons Animated"
    data-mode="Forecast"
    data-days="5"
    data-theme="weather_one"
    data-textcolor="#696969"
    data-highcolor="#696969"
    data-lowcolor="#696969"
    data-suncolor="#ffc676"
    data-mooncolor="#d6c2a6"
    data-cloudcolor="#c3bfb9"
    data-cloudfill="#c3bfb9"
    data-raincolor="#588edb"
    data-snowcolor="#588edb"
  >
    Karteros, Greece
  </a>
</div>

<div id="weatherGr" style="display: none">
  <div class="row">
    <div class="column-large">
      <p>
        Ο καιρός στο <b> {{ main_location }} </b>
      </p>
    </div>
    <div class="column-small">
      <a
        class="weatherwidget-io"
        [attr.href]="weatherHrefGr"
        data-font="Roboto"
        data-icons="Climacons Animated"
        data-mode="Current"
        data-textcolor="#696969"
        data-highcolor="#696969"
        data-lowcolor="#696969"
        data-suncolor="#ffc676"
        data-mooncolor="#d6c2a6"
        data-cloudcolor="#c3bfb9"
        data-cloudfill="#c3bfb9"
        data-raincolor="#588edb"
        data-snowcolor="#588edb"
      >
        Karteros, Greece
      </a>
    </div>
  </div>

  <a
    class="weatherwidget-io"
    [attr.href]="weatherHrefGr"
    data-font="Roboto"
    data-icons="Climacons Animated"
    data-mode="Forecast"
    data-days="5"
    data-theme="weather_one"
    data-textcolor="#696969"
    data-highcolor="#696969"
    data-lowcolor="#696969"
    data-suncolor="#ffc676"
    data-mooncolor="#d6c2a6"
    data-cloudcolor="#c3bfb9"
    data-cloudfill="#c3bfb9"
    data-raincolor="#588edb"
    data-snowcolor="#588edb"
  >
    Karteros, Greece
  </a>
</div>
